import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-rexroth.json";
export default createInventoryBrandPage("rexroth");

export async function getStaticProps() {
	return { props: { db } };
}
